export const COLOR = {
  BORDER: `rgba(0, 0, 0, 0.1)`,
  WHITE: `rgba(255, 255, 255)`,
  TEXT_DARK: `rgb(49 46 129)`,
  BLUE: `rgb(24, 144, 255)`,
}
